<div class="adf-page">
  <div class="adf-hero">
    <p class="adf-hero-text">
      Configure inbox settings for action management including TAT filters, SLA timers, and custom field display options.
    </p>
  </div>

  <div class="adf-settings">
    <form [formGroup]="inboxForm" class="adf-settings-card" *ngIf="inboxForm">
      <div class="adf-setting-columns">
        <div class="adf-setting-row">
          <div class="adf-setting-copy">
            <label class="adf-setting-label" for="inbox-tat-filter">
              Active Inbox TAT Filter
            </label>
            <p class="adf-setting-desc">
              Enable TAT-based filtering in the inbox view
            </p>
          </div>
          <label class="adf-switch">
            <input type="checkbox" id="inbox-tat-filter"
              formControlName="activeInboxTATFilter"
              (change)="onCheckboxChange('activeInboxTATFilter', $any($event.target).checked)">
            <span class="adf-switch-slider"></span>
          </label>
        </div>
  
        <div class="adf-setting-row">
          <div class="adf-setting-copy">
            <label class="adf-setting-label" for="sla-timer">
              Activate SLA Timer Function
            </label>
            <p class="adf-setting-desc">
              Enable SLA timer functionality for tracking action resolution times
            </p>
          </div>
          <label class="adf-switch">
            <input type="checkbox" id="sla-timer"
              formControlName="activateSLATimerFunction"
              (change)="onCheckboxChange('activateSLATimerFunction', $any($event.target).checked)">
            <span class="adf-switch-slider"></span>
          </label>
        </div>
      </div>

      <div class="adf-customise-section">
        <div class="adf-setting-copy">
          <label class="adf-setting-label">
            Customise Inbox
          </label>
          <p class="adf-setting-desc">
            Select additional fields to display in Inbox (Upto 5 fields)
          </p>
        </div>

        <div class="adf-field-grid">
          <label *ngFor="let field of availableFields" class="adf-field-item"
            [class.adf-field-item--disabled]="readonly || (selectedInboxList.length >= 5 && !field.selected)">
            <input type="checkbox"
              [disabled]="readonly || (selectedInboxList.length >= 5 && !field.selected)"
              [id]="'field-' + field.key"
              [checked]="isCustomFieldSelected(field.key)"
              (change)="onCustomFieldToggle(field.key, $any($event.target).checked)">
            <span class="adf-field-check" aria-hidden="true"></span>
            <span class="adf-field-label">{{ field.label }}</span>
          </label>
        </div>
      </div>

      <div class="adf-settings-footer" >
        <button type="button" class="adf-btn adf-btn--ghost" (click)="cancelConfiguration()"
          [disabled]="!isSaveEnabled || isCancelling || readonly">Cancel</button>
        <button type="button" class="adf-btn adf-btn--primary" (click)="saveConfiguration()"
          [disabled]="!isSaveEnabled || isSaving || readonly">Save</button>
      </div>
    </form>
  </div>
</div>
